// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

@Component({
    name: 'RichText',
    mixins: [
        template,
    ]
})
export class RichText extends Vue {


    @Prop()
    public content!: string

    @Prop({default: "primary"})
    public theme!: string
}